import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { IBusLocation } from "@/domain/entities/lineInfo";
import {
  AllocStatusCode,
  BusStopEventCode,
  ITurnBusLastSeatCount,
} from "@/types";

import { onMounted, ref, PropType, computed } from "vue";
import InlineSvg from "vue-inline-svg";
import { useRoute } from "vue-router";


const __default__ = {
  name: "BusOrderSelectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busLocations: {
    type: Array as PropType<IBusLocation[]>,
    required: true,
  },
  isBusRunning: {
    type: Boolean,
    default: false,
  },
  selectedBus: {
    type: Object as PropType<IBusLocation>,
  },
  turnBusLastSeatCountList: {
    type: Array as PropType<ITurnBusLastSeatCount[]>,
    default: () => [],
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onItemSelected", "hideModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "736002d8-modalHeightPx": (modalHeightPx),
  "736002d8-modalMaxHeightPx": (_unref(modalMaxHeightPx))
}))

const props = __props;

const emit = __emit;

const route = useRoute();

const showModal = ref(true);

const activeBusLocations = computed(() => {
  return props.busLocations.filter((location) => {
    const lastBusStop =
      location.busStopEvents[location.busStopEvents.length - 1];

    // 운행을 종료했거나, 마지막 정류장에 도착 or 진출한 경우 제외
    return (
      location.allocStatusCode !== AllocStatusCode.DRIVEN &&
      lastBusStop.busStopEventCode !== BusStopEventCode.Arrive &&
      lastBusStop.busStopEventCode !== BusStopEventCode.LastLeave
    );
  });
});

const onItemSelected = (allocUid: string) => {
  emit("onItemSelected", allocUid);
  hideModal();
};

const hideModal = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  emit("hideModal");
};

const calculateModalMaxHeight = () => {
  const windowHeightPx = window.innerHeight - 106;
  let count = 1;

  while (count * BUS_ORDER_ROW_HEIGHT_PX < windowHeightPx) {
    count++;
  }

  return `${(count - 1) * BUS_ORDER_ROW_HEIGHT_PX}px`;
};

const BUS_ORDER_ROW_HEIGHT_PX = 58;
const modalHeightPx = `${
  activeBusLocations.value.length * BUS_ORDER_ROW_HEIGHT_PX
}px`;
const modalMaxHeightPx = calculateModalMaxHeight();

const sliceCarNo = (busCarNo?: string) => {
  if (!busCarNo) {
    return ["-"];
  }

  if (busCarNo.length < 4) return [busCarNo];

  return [busCarNo.slice(0, -4), busCarNo.slice(-4)];
};

const displayLastSeatCount = (index: number) => {
  if (!props.isBusRunning) {
    return "";
  }

  const selectedBusRemainSeatCount = props.turnBusLastSeatCountList[index];

  if (!selectedBusRemainSeatCount) {
    return "";
  }

  const { boardingCount, remainSeatCount } = selectedBusRemainSeatCount;

  if (props.isInsideShuttle) {
    return boardingCount === -1 ? "" : `탑승 ${boardingCount}`;
  }

  return remainSeatCount === -1 ? "" : `잔여 ${remainSeatCount}`;
};

onMounted(() => {
  route.meta.onBackHandlerList.push(hideModal);
});

const __returned__ = { props, emit, route, showModal, activeBusLocations, onItemSelected, hideModal, calculateModalMaxHeight, BUS_ORDER_ROW_HEIGHT_PX, modalHeightPx, modalMaxHeightPx, sliceCarNo, displayLastSeatCount, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})